import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "clip-fields" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]

import StudioSelectField from "../../../StudioSelectField.vue";
import { computed, inject, watchEffect, type Ref } from "vue";
import { normalizeDialogueInput, sanitizeDialogueInput, preventDialogueLineBreak } from "../../utils/dialogueTextInput";
import type { DialogueClip, DialogueAdvanceMode } from "../../types/DialogueNode";
import { getDialogueStyles } from "../../config/dialogueStyleRegistry";
import { applyStyleParameters, syncStyleParameters } from "../../utils/styleParameters";
import StyleParameterFields from "./StyleParameterFields.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogueClipEditor',
  props: {
    clip: {},
    duration: {}
  },
  setup(__props: any) {

const props = __props;
const advanceMode = computed({
  get: () => props.clip.advanceMode,
  set: (value: DialogueAdvanceMode) => {
    if (value === "None" && props.clip.duration === undefined) {
      props.clip.duration = Math.max(0.1, props.duration ?? 2);
    }
    props.clip.advanceMode = value;
  },
});
const autoContinue = computed({
  get: () => props.clip.autoContinue,
  set: (value: number | string) => {
    props.clip.autoContinue = typeof value === "number" && Number.isFinite(value) ? value : -1;
  },
});
const content = computed({
  get: () => props.clip.content,
  set: (value: string) => { props.clip.content = normalizeDialogueInput(value); },
});
const dialogueStyles = inject<Ref<ReturnType<typeof getDialogueStyles>>>("dialogueStyleOptions", computed(() => getDialogueStyles()));
const stylesReady = inject<Ref<boolean>>("dialogueStylePresetsReady", computed(() => true));
watchEffect(() => { if (stylesReady.value) syncStyleParameters(props.clip, dialogueStyles.value); });
const selectedStyle = computed({
  get: () => props.clip.style,
  set: (value: string) => {
    props.clip.style = value;
    applySelectedStyle();
  },
});
const changedParameters = computed(() => {
  const style = dialogueStyles.value.find(item => item.id === props.clip.style);
  return stylesReady.value && style && JSON.stringify(style.parameters ?? []) !== JSON.stringify(props.clip.parameterPreset?.parameters ?? []);
});
function applySelectedStyle() {
  if (!stylesReady.value) return;
  const style = dialogueStyles.value.find(item => item.id === props.clip.style);
  if (style) applyStyleParameters(props.clip, style);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _cache[9] || (_cache[9] = _createTextVNode(" 对话样式 ", -1)),
      _createVNode(StudioSelectField, {
        modelValue: selectedStyle.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStyle).value = $event)),
        disabled: !_unref(stylesReady),
        "aria-label": "对话样式"
      }, {
        default: _withCtx(() => [
          (!_unref(dialogueStyles).some(item => item.id === __props.clip.style))
            ? (_openBlock(), _createElementBlock("option", {
                key: 0,
                value: __props.clip.style
              }, _toDisplayString(__props.clip.style || '未设置') + "（当前值）", 9, _hoisted_2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogueStyles), (style) => {
            return (_openBlock(), _createElementBlock("option", {
              key: style.id,
              value: style.id
            }, _toDisplayString(style.label) + "（" + _toDisplayString(style.id) + "） ", 9, _hoisted_3))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _createElementVNode("label", null, [
      _cache[10] || (_cache[10] = _createTextVNode("说话人", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.clip.speaker) = $event))
      }, null, 512), [
        [_vModelText, __props.clip.speaker]
      ])
    ]),
    _createElementVNode("label", null, [
      _cache[11] || (_cache[11] = _createTextVNode("台词内容", -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((content).value = $event)),
        rows: "3",
        placeholder: "换行请写 \\n",
        onBeforeinput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(preventDialogueLineBreak) && _unref(preventDialogueLineBreak)(...args))),
        onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(sanitizeDialogueInput) && _unref(sanitizeDialogueInput)(...args)))
      }, null, 544), [
        [_vModelText, content.value]
      ])
    ]),
    _createElementVNode("label", null, [
      _cache[12] || (_cache[12] = _createTextVNode("副标题", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.clip.subtitle) = $event))
      }, null, 512), [
        [_vModelText, __props.clip.subtitle]
      ])
    ]),
    _createVNode(StyleParameterFields, {
      modelValue: __props.clip.nodeGraphEvent,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.clip.nodeGraphEvent) = $event)),
      parameters: __props.clip.parameterPreset?.parameters,
      label: "对话参数",
      "preset-label": "对话类型"
    }, null, 8, ["modelValue", "parameters"]),
    (changedParameters.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "apply-parameters",
          type: "button",
          onClick: applySelectedStyle
        }, "应用预设参数（恢复默认值）"))
      : _createCommentVNode("", true),
    _createElementVNode("label", null, [
      _cache[14] || (_cache[14] = _createTextVNode(" 推进方式 ", -1)),
      _createVNode(StudioSelectField, {
        modelValue: advanceMode.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((advanceMode).value = $event))
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
          _createElementVNode("option", { value: "PlayerInput" }, "玩家按下", -1),
          _createElementVNode("option", { value: "None" }, "不触发按下", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("small", { class: "advance-hint" }, " 黄色标记控制 ContinueDelayTime；不触发按下时导出为 -1，且不生成出口。 玩家按下时右端跟随 Timeline 末尾；不触发按下时可调整持续时间，并在右侧继续添加对话。 ", -1)),
    _createElementVNode("label", null, [
      _cache[15] || (_cache[15] = _createTextVNode(" 自动推进等待时间（秒） ", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((autoContinue).value = $event)),
        type: "number",
        step: "0.1"
      }, null, 512), [
        [
          _vModelText,
          autoContinue.value,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("small", { class: "advance-hint" }, "默认 -1，即使用全局自动推进时间，为 10s。", -1))
  ]))
}
}

})